import {FC} from 'react'

const Header: FC = () => {
  return <></>
}

export {Header}
